import { throwError } from "@/lib/throwError";
import { appendServiceDeskQuery } from "@/lib/serviceDeskApiParams";
import { del, get } from "@/services/axiosUitils";
import {
  ImportListResponse,
  ImportListResponsePaginated,
} from "@/utils/types/importManagement";

class ImportManagementService {
  getImportList = async (
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    return await get<ImportListResponse>(
      appendServiceDeskQuery(`/import-data/?page=${page}&page_size=${pageSize}`)
    );
  };

  getImportDetail = async (
    importId: string
  ): Promise<ImportListResponsePaginated> => {
    if (!importId) {
      throwError("Import ID is required", "ImportManagementService");
    }
    return await get<ImportListResponsePaginated>(
      appendServiceDeskQuery(`/import-data-by-id/${importId}/`)
    );
  };

  getImportsBySchema = async (
    schemaName: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    if (!schemaName) {
      throwError("Schema name is required", "ImportManagementService");
    }
    return await get<ImportListResponse>(
      appendServiceDeskQuery(
        `/import-data/?schema_name=${encodeURIComponent(schemaName)}&page=${page}&page_size=${pageSize}`
      )
    );
  };

  getImportsByStatus = async (
    status: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    if (!status) {
      throwError("Status is required", "ImportManagementService");
    }
    return await get<ImportListResponse>(
      appendServiceDeskQuery(
        `/import-data/?status=${encodeURIComponent(status)}&page=${page}&page_size=${pageSize}`
      )
    );
  };

  deleteImportRecord = async (id: string): Promise<void> => {
    return await del<void>(appendServiceDeskQuery(`/import-data/record/${id}/`));
  };
}

const instance = new ImportManagementService();
export default instance;
